<template>
    <transition :name="transitionName">
        <div class="modal-background" @click="checkHide">
            <transition :name="contentTransitionName" appear>
                <slot></slot>
            </transition>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: null
        },
        hideOnClickOutside: {
            type: Boolean,
            default: true
        },
        transitionName: {
            type: String,
            default: 'el-fade-in'
        },
        contentTransitionName: {
            type: String,
            default: 'section-scale-up-bounce'
        }
    },
    methods: {
        removeModal() {
            this.$emitBubbleFirst('remove', this.$parent)
        },
        checkHide(e) {
            if (this.hideOnClickOutside && e.target === this.$el) this.removeModal()
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.modal-background
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    border-radius inherit
    backdrop-filter blur(3px)
    background-color rgba(255, 255, 255, 0.2)
    // background-color rgba(0, 0, 0, 0.4)
    background radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.69) 100%)
    z-index 1000
    display flex
    flex-direction column
    justify-content center
    align-items center
    box-sizing border-box
    pointer-events all
</style>



// WEBPACK FOOTER //
// src/modules/modals/components/ModalBackground.vue